export enum TAB_TYPES {
  button = 'button',
  link = 'link',
}
